<template>
  <div>
    <tongyongList   > </tongyongList> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
// 本次为做的通用模版，直接通过传递参数给通用模版显示即可，无需修改模版程序
// 传递参数为
// 查询关键字
// 表名
// 字段列表名称
// 字段名称显示

import tongyongList from '../../tongyong/yuyue.vue';
 
export default {

  components: {
    tongyongList: tongyongList 
  },

  data() {
    return {
      // 通用页面配置文件
      // pageData: {
      //   tableName: 'tbl_yuyue',
      //   fieldChinese: ['标题', '客户编号', '客户名称', '预约到店时间', '添加日期'],
      //   field: ['title', 'guest_bianhao', 'guest_name', 'yuyue_time', 'add_time'],
      //   pageSubject: '预约',
      //   pageTitle01: '首页',
      //   pageTitle02: '施工管理',
      //   pageTitle03: '预约管理',
      //   pageName: 'yuyue',
      //   caozuoType: 0,
      //   diaoyongType: 0,
      //   query_condition: ''
      // }
      // 获取用户列表参数
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
